import React from 'react';
import PropType from 'prop-types';

// Lib
import TABLE_DATA, { cellTooltips, cellNames } from '../../../lib/constants/table';

// Atoms
import {
	ColumnWrapper, Cell, CellWrapperResult, CellsWrapper,
} from './Table.atoms';

// Components
import TableColumn from './TableColumn';
import { ResultContext } from '../../Context/ResultContext';
import { Divider } from '../../../../../Atoms/Dividers';

const displayNumberForCells = (text) => {
	switch (text) {
	case cellNames.ONE:
		return 1;
	case cellNames.TWO:
		return 2;
	case cellNames.THREE:
		return 3;
	case cellNames.FOUR:
		return 4;
	case cellNames.FIVE:
		return 5;
	case cellNames.SIX:
		return 6;
	default:
		return null;
	}
};

const Table = ({
	tableData,
	onClick,
	turn,
	opponent,
	announce,
	cancelAnnouncement,
	rollsLeft,
	command,
	opponentTable,
	singlePlayer,
	hideResults,
}) => {
	const { firstSectionTotal, middleSectionTotal, lastSectionTotal } = React.useContext(ResultContext);
	const lastSection = [...TABLE_DATA.cells];
	const firstSection = lastSection.splice(0, 6);
	const middleSection = lastSection.splice(0, 2);
	return (
		<>
			{singlePlayer && <Divider.BigMarginDivider />}
			<ColumnWrapper turn={turn} opponent={opponent} className={opponentTable ? 'enemy-board' : ''}>
				<CellsWrapper>
					<Cell />
					{firstSection.map(cell => (
						<Cell
							key={cell}
							data-tip={cellTooltips[cell]}
							data-place="left"
						>
							{displayNumberForCells(cell)}
						</Cell>
					))}
					<Cell />
					{middleSection.map(cell => (
						<Cell
							key={cell}
							data-tip={cellTooltips[cell]}
							data-place="left"
						>
							{cell}
						</Cell>
					))}
					<Cell />
					{lastSection.map(cell => (
						<Cell
							key={cell}
							data-tip={cellTooltips[cell]}
							data-place="left"
						>
							{cell}
						</Cell>
					))}
					<Cell />
				</CellsWrapper>
				{tableData.map((column) => {
					const lastSectionCells = [...column.cells];
					const firstSectionCells = lastSectionCells.splice(0, 6);
					const middleSectionCells = lastSectionCells.splice(0, 2);

					return (
						<TableColumn
							rollsLeft={rollsLeft}
							cancelAnnouncement={cancelAnnouncement}
							announce={announce}
							key={column.id}
							onClick={onClick}
							column={column}
							columnId={column.id}
							firstSection={firstSectionCells}
							middleSection={middleSectionCells}
							lastSection={lastSectionCells}
							opponentTable={opponentTable}
							command={command}
						/>
					);
				})}
				{hideResults !== true && (
					<CellWrapperResult turn={turn}>
						<Cell style={{ gridRowStart: 8, borderLeft: 'unset' }}>{firstSectionTotal}</Cell>
						<Cell style={{ gridRowStart: 11, borderLeft: 'unset' }}>{middleSectionTotal}</Cell>
						<Cell style={{ gridRowStart: 17, borderLeft: 'unset' }}>{lastSectionTotal}</Cell>
					</CellWrapperResult>
				)}
			</ColumnWrapper>
		</>
	);
};

Table.defaultProps = {
	onClick: () => { },
	opponent: false,
	singlePlayer: false,
	opponentTable: false,
	cancelAnnouncement: () => { },
	hideResults: false,
};

Table.propTypes = {
	command: PropType.shape({}).isRequired,
	opponentTable: PropType.bool,
	singlePlayer: PropType.bool,
	rollsLeft: PropType.number.isRequired,
	cancelAnnouncement: PropType.func,
	announce: PropType.shape({}).isRequired,
	onClick: PropType.func,
	tableData: PropType.arrayOf(PropType.shape({
		name: PropType.string,
		isActive: PropType.bool,
		rows: PropType.arrayOf(PropType.shape({
			name: PropType.string,
			isActive: PropType.bool,
			value: PropType.number,
		})),
	})).isRequired,
	opponent: PropType.bool,
	turn: PropType.bool.isRequired,
	hideResults: PropType.bool,
};

export default Table;
